import {useTranslation} from "@Translation/hooks/useTranslation";
import {multiModalTranslationKey} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";
import TipsPerTransportType from "@SearchResults/features/staticContent/components/TipsPerTransportType";
import Tip from "@SearchResults/features/staticContent/features/multiModal/features/tips/components/Tip";
import OperatorsList from "@SearchResults/features/staticContent/components/OperatorsList";
import Translation from "@Translation/components/Translation";
import getTravelTimes from "@SearchResults/features/staticContent/functions/getTravelTimes";
import RouteType from "@Route/types/Route.type";

interface FlightTipsContentProps {
    departure: string,
    destination: string,
    distanceAirMiles: string,
    routes: RouteType[]
    operators: string[]
}

function FlightTipsContent(props: FlightTipsContentProps) {
    const {
        departure,
        destination,
        distanceAirMiles,
        routes,
        operators,
    } = props

    const {minTime} = getTravelTimes(routes)

    const title = useTranslation(
        `${multiModalTranslationKey}.flights.title`,
        {departure, destination}
    )

    const description = useTranslation(
        `${multiModalTranslationKey}.flights.desc1`,
        {departure, destination, distanceAirMiles, durationMin: minTime}
    )

    const {
        title: o1Title,
        desc: o1Desc,
    } = useTranslation(`${multiModalTranslationKey}.flights.trip_details.o1`)

    const {
        title: o2Title,
        desc: o2Desc,
    } = useTranslation(`${multiModalTranslationKey}.flights.trip_details.o2`)

    const {
        title: o3Title,
        desc: o3Desc,
    } = useTranslation(`${multiModalTranslationKey}.flights.trip_details.o3`)

    return (
        <>
            <TitleAndContent
                title={title}
                content={description}
            />
            <TipsPerTransportType
                subtitle={(
                    <Translation translationKey={`${multiModalTranslationKey}.flights.trip_details.title`}/>
                )}
                options={[
                    {
                        id: "flight-o1",
                        option: (<Tip title={o1Title} description={o1Desc}/>),
                    },
                    {
                        id: "flight-o2",
                        option: (<Tip title={o2Title} description={o2Desc}/>),
                    },
                    {
                        id: "flight-o3",
                        option: (<Tip title={o3Title} description={o3Desc}/>),
                    },
                ]}
            />
            <OperatorsList
                title={(
                    <Translation
                        translationKey={`${multiModalTranslationKey}.flights.operators_list.title`}
                        translationVariables={{departure, destination}}
                    />
                )}
                operators={operators}
            />
        </>
    )
}

export default FlightTipsContent